import { useAsiKnowledgeReadConfigVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useAsiKnowledgeReadConfigVariation.js';
const DEFAULT_ASI_KNOWLEDGE_READ_CONFIG = {};
export function useComputerMemoryPageVisible() {
    const { variation, loading } = useAsiKnowledgeReadConfigVariation({
        defaultValue: DEFAULT_ASI_KNOWLEDGE_READ_CONFIG,
    });
    return { visible: !loading && (variation.ui_visible ?? false), loading };
}
//# sourceMappingURL=useComputerMemoryPageVisible.js.map